import { FC, HTMLAttributes, HTMLInputTypeAttribute, InputHTMLAttributes, SVGProps } from 'react';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  labelColor?: InputLabelColor | any;
  questionText?: string;
  error?: string;
  divProps?: HTMLAttributes<HTMLDivElement>;
  onChangeValue?: (value: string) => void;
  startIcon?: FC<SVGProps<SVGSVGElement>>;
  endIcon?: FC<SVGProps<SVGSVGElement>>;
  onPressEnter?: () => void;
  isCompany?: boolean;
  type?: HTMLInputTypeAttribute | 'textarea';
}

export enum InputLabelColor {
  White = 'White',
  Black = 'Black',
  Dark = 'Dark',
  Light = 'Light',
}
